import { notifyNative } from 'src/bridges';
import { Enums } from '../enums';

// 定义错误上报参数接口
export interface ErrorOptions {
  key?: string; // 错误分类标识（如 'jsRuntimeError'）
  message: string | Event; // 错误信息（可为字符串或 Event 对象）
  apiName?: string; // 调用的 API 名称
  keywords?: string; // 关键词（用于筛选日志）
  fwkVersion?: string; // 框架版本号
  file?: string; // 出错文件路径
  line?: number; // 行号
  column?: number; // 列号
  timestamp?: Date;
  stack?: string; // 堆栈信息
}

export const reporter = {
  /**
   * 标准化错误信息并上报到原生层
   * @param params 错误参数（需包含 message 字段）
   */
  normalError(params: ErrorOptions) {
    // 处理 message 为 Event 对象的情况（如资源加载失败的 event）
    const messageStr =
      params.message instanceof Event
        ? (params.message as Event).toString()
        : String(params.message);

    // 构造上报数据
    const data = {
      key: params.key || 'MacleApiError', // 默认错误分类
      stack: params.stack || messageStr, // 优先使用 stack，否则用 message
      apiName: params.apiName,
      keywords: params.keywords,
      fwkVersion: '',
      file: params.file,
      line: params.line,
      column: params.column,
      timestamp: Date.now()
    };

    // 原生上报
    try {
      notifyNative(Enums.MACLE_ERROR_LOG, data);
    } catch (e) {
      console.log('Native error reporting failed:', e);
    }

    // 控制台输出错误信息
    console.error(params?.message);
  }
};
